var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userIsLoggedIn)?_c('DefaultLayout',[_c('template',{slot:"header"},[_c('Headerbar')],1)],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }